export const API_URL = {
    BASEURL: process.env.REACT_APP_APIBASEPATH,
    WORKFLOWSAVE: "WorkFlow/save",
    WORKFLOWCOPY: "WorkFlow/copy-workflow",
    WORKFLOWRUNWORKFLOW: "WorkFlow/run_workflow",
    WORKFLOWGETLIST: "WorkFlow/getlist",
    WORKFLOWGETLISTFORDDL: "WorkFlow/getlistforddl",
    GETWORKFLOWTIMELINE: "WorkFlow/getworkflowtimeline",
    MACHINEGETLIST: "Machine/getlist",
    MACHINECATEGORYGETLIST: "MachineCategory/getlist",
    WORKFLOWGETDETAILSBYPRIMARYKEY: "WorkFlow/getdetailsbyprimarykey",
    WORKFLOWGETWORKFLOWLOGDATABYWORKFLOWID:
        "WorkFlow/getworkflowlogdatabyworkflowid",
    WORKFLOWLOGGETLIST: "WorkFlow/workflowloggetlist",
    GETWORKFLOWLOGDATABYWORKFLOWID: "WorkFlow/getworkflowlogdatabyworkflowid",
    GET_MACHINE_CHART_FROM_WORKFLOWULOGID: "WorkFlow/getmachinechartfromworkulogid",
    WORKFLOWMACHINELOGGETLIST: "WorkFlow/workflowmachineloggetlist",
    USERLOGIN: "Login/userlogin",
    USER_GOOGLE_LOGIN: "Google/google-callback",
    GOOGLE_TOKEN: "Google/google-token",
    MICROSOFT_GET_REDIRECT_URL: "MicrosoftApp/get-redirect-url",
    MICROSOFT_TOKEN: "MicrosoftApp/microsoft-token",
    DROPBOX_GET_REDIRECT_URL: "DropboxApp/get-redirect-url",
    DROPBOX_TOKEN: "DropboxApp/dropbox-token",
    OAUTH_VAULT_GET_REDIRECT_URL: "OAuthVault/get-redirect-url",
    OAUTH_VAULT_TOKEN: "OAuthVault/token",
    CATEGORYGETLIST: "Category/getlist",
    MACHINEGETLISTBYSEARCH: "Machine/getlistbysearch",
    GETMACHINEDROPDOWNLIST: "Machine/get-machine-dropdown-list",
    MACHINEGETBYPRIMARYKEYINDETAILS: "Machine/getbyprimarykeyindetails",
    PROJECTTERMGETLIST: "ProjectTerm/getlist",
    MACHINESAVE: "Machine/save",
    MACHINEVALIDATEZIPFILE: "Machine/validatezipfile",
    INDUSTRYGETLIST: "Industry/getlist",
    MACHINEGETLISTBYSUBSCRIBERID: "Machine/getlistbysubscriberid",
    GET_WORKFLOW_CRON_EXPRESSION: "WorkFlow/cronexpression",
    GET_WORKFLOW_DETAIL_BY_ID: "WorkFlow/getbydetails",
    // Workspace
    GET_WORKSPACE_LIST_BY_ID: "Workspace/getworkspacelistbyworkflowid",
    GET_SUBSCRIBER_MACHINE_LIST: "Machine/getsubscribermachinelist",
    SAVE_MACHINE_SUBSCRIBER: "Machine/savemachinesubscriber",
    SUBSCRIBERS_SAVE: "Subscribers/save",
    SUBSCRIBERS_DEV_DASHBOARD: "Subscribers/dev-dashboard",
    SUBSCRIBERS_DEV_KPIS: "Subscribers/dev-kpis",
    SUBSCRIBERS_DEV_USAGE_REVENUE_TREND: "Subscribers/dev-usage-revenue-trend",
    SUBSCRIBERS_DEV_WORKFLOW_USAGE: "Subscribers/dev-workflow-usage",
    SUBSCRIBERS_DEV_RUN_STATUS_TREND: "Subscribers/dev-run-status-trend",
    SUBSCRIBERS_DEV_PERFORMANCE: "Subscribers/dev-performance",
    SUBSCRIBERS_DEV_PORTFOLIO_LIST: "Subscribers/dev-portfolio-list",
    SUBSCRIBERS_DEV_SKILLS_CATEGORIES: "Subscribers/dev-skills-categories",
    SUBSCRIBERS_DEV_SUPPORT_NOTES: "Subscribers/dev-support-notes",

    SEND_SIGNUP_OTP: "Login/send-signup-otp",
    VERIFY_SIGNUP_OTP: "Login/verify-signup-otp",

    GET_WORKFLOW_SCHEDULE_LOG_LIST: "AllLog/workflowscheduleloggetlist",
    GET_WORKFLOW_SCHEDULE_MACHINE_LOG_LIST: "AllLog/workflowschedulemachineloggetlist",
    GET_SANDBOXMACHINELOGDETAILS: "AllLog/sandboxmachinelogdetails",
    GET_WORKFLOW_SCHEDULE_MACHINE_LOG_LIST_BYWORKFLOWULOGID: "AllLog/workflowschedulemachineloggetlistbyworkflowulogid",
    GET_MACHINE_LOG_STREAM: "AllLog/machinelogstream",

    VERIFY_OTP: "Login/verifyotp",
    CHANGE_PASSWORD: "Login/changepassword",
    FORGET_PASSWORD: "Login/forgetpassword",
    MACHINE_FAQ_LIST: "MachineFaq/getlist",
    PROFILE_DETAIL: "User/getbyprimarykey",
    // PROFILE_UPDATE: "User/updateprofile", //old
    PROFILE_UPDATE: "User/update-profile", //new
    CONTACT_GETLIST: "SubscribersContact/getlist",
    CONTACT_DETAILS: "SubscribersContact/getbyprimarykey",
    SUBSCRIBERS_CONTACT_SAVE: "SubscribersContact/save",
    SUBSCRIBERS_CONTACT_DELETE: "SubscribersContact/delete",
    EKS_NODE_GROUP: {
        GET_LIST: "EKSNodeGroup/getlist",
        SAVE: "EKSNodeGroup/save",
        DELETE: "EKSNodeGroup/delete",
        GET_SUBNET: "EKSNodeGroup/subnets",
        GET_AWS_INSTANCES: "EKSNodeGroup/aws-instances",
        UPDATE_MIN_SIZE: "EKSNodeGroup/update-min-size",
        CHECK_STATUS: "EKSNodeGroup/check-status",
    },
    GET_MACHINE_VERSION: "Machine/getmachineversion",
    DEPRECATE_MACHINE: "Machine/deprecate-machine",
    DISCONTINUE_MACHINE: "Machine/discontinue-machine",
    MACHINE_VERSION_UPDATE: "Machine/machine-version-update",

    // Login with Github
    LOGIN_GITHUB_WITH_USER: "Git/github-callback-verify",
    LOGIN_GITHUB: "Git/github-callback",
    MACHINE_LOGO_GETLIST: "Logo/getlist",

    MACHINE: {
        UPDATE_REVIEWR_COMMENT: "Machine/update-reviewer-comment",
        GET_REVIEWR_COMMENT: "Machine/get-reviewer-comment",
        GET_MACHINE_VERSION_BY_MACHINE_ID: "Machine/get-machine-version",
        UPDATE_MACHINE_STATUS: "Machine/machineapprove",
        GET_LIST_BY_REVIEWER_ID: "Machine/getlistbyreviewerid",
        CHANGE_MACHINE_RETIREMENT_STATUS: "Machine/change-machineretirment-status",
        GET_MY_MACHINE_LIST: "Machine/getmymachinelist",
        UPDATE_MACHINE: "Machine/update",
        GET_SIMILAR_MACHINE_LIST: "Machine/get-similar-machine-list",
        GET_GIT_REPO_STRUCTURE: "Machine/get-gitrepo-structure",
        GET_GIT_REPO_FILE_CONTENT: "Machine/get-gitrepo-filecontent",
        GET_MACHINE_PURCHASE_LIST: "Machine/machine-purchase-list",
        UPGRADE_MACHINE: "Machine/machine-upgrade",
        GET_MACHINE_DASHBOARD_LIST: "Machine/get-machine-dashboard-list",
        GET_MACHINE_PORTFOLIO_LIST: "Machine/get-machine-portfolio-list",
        GET_MACHINE_VERSION_DETAIL: "Machine/get-machine-version-detail",
        MACHINE_VERSION_REMOVE_FROM_LIBRARY:
            "Machine/machine-version-remove-from-library",
        MACHINE_DELETE: "Machine/machine-delete",
        GET_ALL_KPI_DATA: "Machine/getallkpidata",
        GET_MACHINE_RUN_STATUS: "Machine/getmachinerunstatus",
        GET_MACHINE_USAGE_TREND: "Machine/getmachineusagetrend",
        GET_MACHINE_EARNING_TREND: "Machine/getmachineearningtrend",
        GET_MACHINE_RESOURCE_USAGE: "Machine/getmachineresourceusage",
    },
    GETALLKPIDATA: "Machine/getallkpidata",
    GETMACHINERUNSTATUS: "Machine/getmachinerunstatus",
    GETMACHINEUSAGETREND: "Machine/getmachineusagetrend",
    GETMACHINEEARNINGTREND: "Machine/getmachineearningtrend",
    GETMACHINERESOURCEUSAGE: "Machine/getmachineresourceusage",
    BILLING_COST_MANAGEMENT: {
        GET_CHARGE_BY_WORKFLOW: "BillingandCostManagement/get-charge-by-workflow",
        GET_CHARGE_BY_MACHINE: "BillingandCostManagement/get-charge-by-machine",
        GET_CHARGE_LIST_WORKFLOW_BY_MACHINE:
            "BillingandCostManagement/get-charge-list-workflow-by-machine",
        GET_INVOICE_LIST: "BillingandCostManagement/get-incoice-list",
    },
    WORKFLOW: {
        GET_CURRENT_WORKFLOW: "WorkFlow/get-current-workflow",
        GET_DASHBOARD_LIST: "WorkFlow/get-dashboard-workflow-list",
        UPDATE_WORKFLOW_STATUS: "WorkFlow/update-workflow-status",
        UPDATE_WORKFLOW_RUNNING_STATUS: "WorkFlow/update-workflow-running-status",
        GET_WORKFLOW_SCHEDULE_DETAIL: "WorkFlow/get-workflow-schedule-detail",
        GET_SCHEDULE_LIST: "WorkFlow/getschedulelist",
        UPDATE_WORKFLOW_DESCRIPTION: "WorkFlow/updateworkflowdescription",
        SAVE_WORKFLOW_PROMPT: "WorkFlow/saveworkflowpromt",
        GET_WORKFLOW_PROMPT: "WorkFlow/getworkflowpromt",
        GET_WORKFLOW_STATISTICS: "WorkFlow/getworkflowstatistics",
        GET_DASHBOARD_TODAY_WORKFLOW_STATISTICS_COUNT: "WorkFlow/getdashboardtodayworkflowstatisticscount",
        GET_MACHINE_WISE_COST_LIST: "WorkFlow/getworkflowmachinewisecost",
        GET_WORKFLOW_TAG_SEARCH_LIST: "WorkFlow/getworkflowtaglistbysearch",
    },
    SUBSCRIBER: {
        UPDATE_SUBSCRIBER_PROFILE: "Subscribers/update-subscriber-profile",
        GET_SUBSCRIBER_PROFILE: "Subscribers/get-subscriber-profile",
        GET_SUBSCRIBER_BY_PRIMARY_KEY: "Subscribers/getbyprimarykey",
        BECOME_DEVELOPER: "Subscribers/become-developer",
        BECOME_CLIENT: "Subscribers/become-client",
        SUBSCRIBERINVITEUSER: "Subscribers/subscriberinviteuser",
        SUBSCRIBERVALIDATEDEACTIVATE: "Subscribers/subscribervalidatedeactivate",
    },
    LOGIN: {
        SEND_EMAIL_OTP: "Login/send-email-otp",
        VERIFY_EMAIL_OTP: "Login/verify-email-otp",
        RESEND_EMAIL_OTP: "Login/resend-email-otp",
        SUBSCRIBERINVITELOGIN: "Login/subscriberinvitelogin",
        GETLOGINDATAUSINGTOKEN: "Login/getlogindatausingtoken",
        USER_LOGIN_LOG_LIST: "Login/userloginloglist",
    },
    SUBSCRIBERSCONTACT: {
        GET_BY_PRIMARY_KEY: "SubscribersContact/getbyprimarykey",
        GET_LIST: "SubscribersContact/getlist",
        SAVE: "SubscribersContact/save",
        DELETE: "SubscribersContact/delete",
        RESEND_VERIFICATION_EMAIL: "SubscribersContact/resend-Verification-mail",
        INVITETODEVELOPER: "SubscribersContact/invitetodeveloper",
        INVITETODATAFACTORY: "SubscribersContact/invitetodatafactory",
    },
    ROLE: {
        GET_BY_ROLE_TYPE: "Role/get-by-roletype",
    },
    WORKFLOWTEAM: {
        INSERT: "WorkflowTeam/insert",
        UPDATE: "WorkflowTeam/update",
        DELETE: "WorkflowTeam/delete",
        GET_BY_PRIMARY_KEY: "WorkflowTeam/getbyprimarykey",
        GET_TEAM_LIST: "WorkflowTeam/getteamlist",
    },

    CATEGORY: {
        GET_USER_CATEGORY_LIST: "Category/get-user-category-list",
    },

    USER: {
        UPDATE_PASSWORD: "User/update-password",
        GETUSERLISTBYSEARCH: "User/get-user-list-by-search",
    },

    AUTH: {
        ENABLE_2FA: "Auth/enable-2fa",
        VERIFY_2FA: "Auth/verify-2fa",
        SEND_2FA_EMAIL_OTP: "Auth/send-2fa-email-otp",
        VERIFY_2FA_EMAIL_OTP: "Auth/verify-2fa-email-otp",
        DISABLE_2FA: "Auth/disable-2fa",
    },

    CASE: {
        CASE_GET_BY_PRIMARY_KEY: "Case/getbyprimarykey",
        CASE_GET_LIST: "Case/getlist",
        CASE_GET_BY_DETAIL: "Case/getbydetail",
        CASE_DELETE: "Case/delete",
        CASE_SAVE: "Case/save",
        CASE_UPDATE_STATUS: "Case/update-status",
        CASE_UPDATE_ASSIGN: "Case/update-assign",
        SAVE_ACTIVITY: "Case/saveactivity",
    },

    NOTIFICATION: {
        GET_LIST: "Notification/getlist",
        UPDATE_NOTIFICATION: "Notification/update",
        READ_ALL: "Notification/readall",
    },

    CART: {
        GET_LIST: "Cart/getlist",
        SAVE: "Cart/save",
        GET_BY_PRIMARY_KEY: "Cart/getbyprimarykey",
        DELETE: "Cart/delete",
        DELETE_CART_DETAIL: "Cart/delete-cart-detail",
    },
    BLOG: {
        GET_LIST: "Blog/getlistoflatestnews",
    },
    ORDER: {
        GET_LIST: "Order/getlist",
        SAVE: "Order/save",
        GET_BY_PRIMARY_KEY: "Order/getbyprimarykey",
    },
    INVOICE: {
        LIST: "Subscribers/subscriberearning",
        GET_INVOISE_BY_ID: "Subscribers/subscriberearningdetail",
        SAVE: "Invoice/save",
        DOWNLOAD_PDF: "Invoice/downloadinvoicepdf",
        GETLIST: "Invoice/getlist",
        AUTO_PAYMENT: "Stripe/auto-payment",
        CREATEPAYMENT: "Stripe/create-payment-intent",
        TOPUPWALLETPAYMENT: "Stripe/wallet-top-up-payment-intent",
        PAYMENTSTATUSCHECK: "Stripe/payment-status-check",
        GET_WALLET_DATA_LIST: "Subscribers/WalletDetailBySubscriberId",
    },
    PAYMENTMETHOD: {
        CREATEPAYMENT: "Stripe/add-payment-method",
        PAYMENTSTATUSCHECK: "Stripe/payment-method-payment-status-check",
        GETLIST: "PaymentMethod/getlist",
        SETPRIMARY: "PaymentMethod/setprimary",
        DELETE: "PaymentMethod/delete",
    },
    TRANSACTION: {
        GETLIST: "Transaction/getlist",
    },
    COMPANY: {
        GET_LIST: "Company/getcompanydetailsbycode",
    },
    NOTIFICATION_SETTING: {
        GET_LIST: "NotificationSetting/getlist",
        SAVE: "NotificationSetting/save",
    },
    USER_MACHINE_REVIEW: {
        SAVE: "UserMachineReview/save",
    },
    WEBHOOKDETAILS: {
        MAKEHOOK: "Webhook/makehook",
        GENERATETOKEN: "Webhook/generatetoken",
        DELETEHOOK: "Webhook/deletehook",
        DETAILSBYHOOKTYPE: "Webhook/detailsbyhooktype",
    },
    PASSOWORDVAULT: {
        GETLIST: "PasswordVault/getlist",
        DELETE: "PasswordVault/delete",
        SAVE: "PasswordVault/save",
        GETBYPRIMARYKEY: "PasswordVault/getbyprimarykey",
    },

    REPORT: {
        GETCOSTWIDGETDATA: "Report/getcostwidgetdata",
        MONTHLYCOSTBYDATABY: "Report/monthlycostbydataby",
        MONTHLY_COST_BY_DATA_BY_WORKFLOW_ID: "Report/monthlycostbydatabyworkflowid",
        GET_DATA_CLOUD_HEALTH_COUNT: "Report/getdashboarddatacloudhealthcount",
        GET_DAILY_ACTIVITY_DATA: "Report/getdashboarddailylactivitydata",
    },
    DIGISIGN: {
        GET_DEVELOPER_VS_CLIENT_CONTRACT: "DigiSign/developervsclientcontract",
        GET_QDL_VS_DEVELOPER_CONTARACT: "DigiSign/qdlvsdevelopercontract",
        GET_ALL_CONTRACT_LIST: "DigiSign/get-all-contract-list",
    },

    WORDPRESS: {
        GET_BLOG_LIST:
            "https://quantumdatalytica.com/wp-json/custom-api/v1/blog-posts",
    },
    DATAPROFILECHECKOUTPUT: "DataProfile/run",
    SUBSCRIPTIONS: {
        GET_LIST: "Subscriptions/getlist",
        GET_MY_SUBSCRIPTION: "Subscriptions/getmycurrentsubscriptions",
        UPDATEPLAN: "Subscriptions/updateplan",
        CALCULATE_PRICE: "Subscriptions/calculatesubscriptionprice",
    },
    SUBSCRIBERSINFRASTRUCTUREAUTOMATION: {
        SAVE: "SubscribersInfrastructureAutomation/save",
        GETBYSUBSCRIBER: "SubscribersInfrastructureAutomation/getbysubscriber",
        DELETE: "SubscribersInfrastructureAutomation/Delete",
        GETRUNNINGLOG: "SubscribersInfrastructureAutomation/getrunninglog",


    },
    DATABASE_SERVICE: {
        LIST: "DatabaseAsService/databases",
        CREATE: "DatabaseAsService/databases",
        START: "DatabaseAsService/databases/{id}/start",
        STOP: "DatabaseAsService/databases/{id}/stop",
        DELETE: "DatabaseAsService/databases/{id}",
        TYPES: "DatabaseAsService/types",
        VERSIONS: "DatabaseAsService/types/{type}/versions",
        TIERS: "DatabaseAsService/types/{type}/tiers",
    },

    SANDBOXWORKFLOW: {
        GETLIST: "SandboxWorkflow/getlist",
        SAVE: "SandboxWorkflow/save",
        GETBYDETAILS: "SandboxWorkflow/getbydetails",
        DELETE: "SandboxWorkflow/delete",
        CONVERWORKFLOWASSANDBOX: "SandboxWorkflow/convertWorkflowassandbox",
    },
};

export const AI_API_URL = {
    BASEURL: process.env.REACT_APP_AI_API_BASEPATH,
    SUGGEST_MACHINES: "suggest_machines",
    GET_MACHINES: "get_machines",
    VECTOR_STORE: "vector_store",
};
